import { PortfolioService } from '@amzn/awscat-portfolio-assessment-service-client';
import { AuthContextInterface, FlashContextInterface, FlashType, withAuthContext, withFlashContext } from '@amzn/awscat-react-components';
import { useEffect } from 'react';
import { match, RouteProps, useHistory, useRouteMatch } from 'react-router-dom';

import { constants } from '../../common/Localization';

interface Params {
    invitationId: string;
}
const portfolioService = new PortfolioService();
const InvitedRedirect = (props: RouteProps & AuthContextInterface & FlashContextInterface) => {
    const history = useHistory();
    const match: match<Params> | null = useRouteMatch({
        path: '/invite/:invitationId',
    });
    const invitationId = match?.params?.invitationId || '';
    useEffect(() => {
        const invite = async () => {
            try {
                await portfolioService.persistPendingPermission(invitationId);
            } catch (err) {
                props.flash.alert(FlashType.error, (err as Error).message, constants.UNABLE_TO_GRANT_ACCESS);
            }
            history.push('/portfolios');
        };
        invite();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return <div>{constants.GRANTING_ACCESS}</div>;
};

export default withFlashContext(withAuthContext(InvitedRedirect));
